import React from 'react';
import CourseProgressWidget from './dashboard/CourseProgressWidget';
import CommunityActivityWidget from './dashboard/CommunityActivityWidget';
import AISuggestionsWidget from './dashboard/AISuggestionsWidget';
import UpcomingEventsWidget from './dashboard/UpcomingEventsWidget';
import StatsWidget from './dashboard/StatsWidget';
const Dashboard = () => {
  return <div className="space-y-4" data-id="element-1146">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1147">
        <div className="col-span-1 md:col-span-2" data-id="element-1148">
          <CourseProgressWidget data-id="element-1149" />
          <div className="mt-4" data-id="element-1150">
            <StatsWidget data-id="element-1151" />
          </div>
          <div className="mt-4" data-id="element-1152">
            <UpcomingEventsWidget data-id="element-1153" />
          </div>
        </div>
        <div className="col-span-1" data-id="element-1154">
          <AISuggestionsWidget data-id="element-1155" />
        </div>
      </div>
    </div>;
};
export default Dashboard;